'use client';
import { useState, useEffect } from 'react';
import { isWindowDefined } from '@utils/validations';

export default function useEscapeClick() {
  const [isEscapeClicked, setIsEscapeClicked] = useState(false);

  useEffect(() => {
    function handleEsc(event: KeyboardEvent) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        setIsEscapeClicked(true);
      }
    }
    if (isWindowDefined) {
      window.addEventListener('keydown', handleEsc);
      return () => window.removeEventListener('keydown', handleEsc);
    }
    return undefined;
  }, []);

  return { isEscapeClicked, setIsEscapeClicked };
}
